import _classCallCheck from "/Users/rizhang/Projects/richardzcode/bootstrap-4-react/site/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/rizhang/Projects/richardzcode/bootstrap-4-react/site/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var GTag =
/*#__PURE__*/
function () {
  function GTag() {
    _classCallCheck(this, GTag);
  }

  _createClass(GTag, [{
    key: "init",
    value: function init(trackingId) {
      this.trackingId = trackingId;

      if (!this.trackingId) {
        console.log('no trackingId');
        return;
      }

      this.createScript();
      this.initDataLayer();
    }
  }, {
    key: "createScript",
    value: function createScript() {
      var script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.trackingId;
      script.async = true;
      document.body.appendChild(script);
    }
  }, {
    key: "initDataLayer",
    value: function initDataLayer() {
      window.dataLayer = window.dataLayer || [];

      window.gtag = function () {
        window.dataLayer.push(arguments);
      };

      window.gtag('js', new Date());
      window.gtag('config', this.trackingId);
    }
  }, {
    key: "gtag",
    value: function gtag() {
      window.dataLayer.push(arguments);
    }
  }, {
    key: "updatePagePath",
    value: function updatePagePath(page_path) {
      this.gtag('config', this.trackingId, {
        'page_path': page_path
      });
    }
  }]);

  return GTag;
}();

var gtag = new GTag();
export default gtag;